import './NavBar.scss'
import './NavPopper.scss'

import { isAuthenticated$ } from '@op/services'
import { memo, useContext } from 'react'
import { useSelector } from 'react-redux'
import { Overlay } from '../Overlay'
import { NavBarCtx } from './NavBarCtx'
import { NavSlideBox } from './NavSlideBox'

const NavBarOutlet = () => {
	const isAuthenticated = useSelector(isAuthenticated$)
	const navBar = useContext(NavBarCtx)

	if (!(navBar && isAuthenticated)) return null

	return (
		<nav className="top-nav-wrapper app-width fixed left-0 right-0 top-0 z-hack">
			<NavSlideBox className="top-nav is-sb-pad bg-white flex h-full items-center relative">
				{navBar}

				<Overlay />
			</NavSlideBox>
		</nav>
	)
}

export default /*@__PURE__*/ memo(NavBarOutlet)
